import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RemitterTypeEnum, RemitterTypes } from '@pg-app/client/payment/constants/remitter-type';

@Component({
  selector: 'np-ultimate-remitter',
  templateUrl: './ultimate-remitter.component.html',
  styleUrls: ['./ultimate-remitter.component.scss']
})
export class UltimateRemitterComponent implements OnInit {
  countries: Array<any> = [];
  remitterDetails: FormGroup;
  remitterTypes = RemitterTypes;

  constructor(
    private dialogRef: MatDialogRef<UltimateRemitterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.countries = this.data.countries;
    this.remitterDetails = this.data.remitterDetails;
  }

  next() {
    if (!this.remitterDetails.valid) {
      this.remitterDetails.markAllAsTouched();
      return;
    }

    const ultimateRemitterIdSelected = this.remitterDetails.get('ultimateRemitterSelected').value;
    const remitterCountry = this.countries.find(p => p.name === this.remitterDetails.get('remitterCountry').value);

    const typeName = this.remitterDetails.get('remitterType').value;
    const type = this.remitterTypes.find(x => x.name.toLowerCase() === typeName?.toLowerCase());

    const result = {
      ultimateRemitterIdSelected: ultimateRemitterIdSelected,

      ultimateRemitterType: ultimateRemitterIdSelected ? null : typeName,

      ultimateRemitterCompanyName: ultimateRemitterIdSelected || type?.id === RemitterTypeEnum.Individual
                                    ? null
                                    : this.remitterDetails.get('remitterCompanyName').value,
      ultimateRemitterCompanyNumber: ultimateRemitterIdSelected || type?.id === RemitterTypeEnum.Individual
                                      ? null
                                      : this.remitterDetails.get('remitterCompanyNumber').value,

      ultimateRemitterFirstName: ultimateRemitterIdSelected || type?.id === RemitterTypeEnum.Company
                                  ? null
                                  : this.remitterDetails.get('remitterFirstName').value,
      ultimateRemitterLastName: ultimateRemitterIdSelected || type?.id === RemitterTypeEnum.Company
                                ? null
                                : this.remitterDetails.get('remitterLastName').value,
      ultimateRemitterDOB: ultimateRemitterIdSelected || type?.id === RemitterTypeEnum.Company
                            ? null
                            : this.remitterDetails.get('remitterDOB').value,

      ultimateRemitterAddress: ultimateRemitterIdSelected ? null : this.remitterDetails.get('remitterAddress').value,
      ultimateRemitterCity: ultimateRemitterIdSelected ? null : this.remitterDetails.get('remitterCity').value,
      ultimateRemitterPostCode: ultimateRemitterIdSelected ? null : this.remitterDetails.get('remitterPostCode').value,
      ultimateRemitterState: ultimateRemitterIdSelected ? null : this.remitterDetails.get('remitterState').value,
      ultimateRemitterCountryId: ultimateRemitterIdSelected ? null : remitterCountry?.id
    };

    this.dialogRef.close(result);
  }

  cancel() {
    this.dialogRef.close();
  }
}
